import {AiChatSuggestedAction} from "./@type";
import {AIChatProvider} from "../../core/model2/ai/@const";

export const DEFAULT_AGENT_LABEL = 'GoodDay Assistant'

export enum AIChatsPanelMode {
    CHAT        = 1,
    CHAT_LIST   = 2,
}

export const TOP_CONTEXT_SELECTOR_RESET = "top-context-selector:reset"
export const AI_CHAT_MESSAGES_UPDATE = "ai-chat-messages:update"
export const AI_CHAT_CONTEXT_CHANGED = "ai-chat-context:changed"
export const AI_CHAT_CONTEXT_VALUE_CHANGED = "ai-chat-context-value:changed"

export const AIProviderOptions: Options = [
    {
        icon    : "ii5-lightning",
        label   : "GPT 4o",
        value   : AIChatProvider.GPT_4
    },
    {
        icon    : "ii5-lightning",
        label   : "GPT 4o mini",
        value   : AIChatProvider.GPT_4o_MINI
    },

    // {
    //     icon    : "ii5-lightning",
    //     label   : "GEMINI 2.5 FLASH",
    //     value   : AIChatProvider.GEMINI_2_5_FLASH
    // }
]


export const aiChat_allSpacesPrompts: AiChatSuggestedAction[] = [
    {
        title    : "Summarize all spaces",
        icon     : "i5-widget-summary",
        isvgIcon : "isvg-progress-report",
        message  : "Summarize the key updates, activity, and priorities across all spaces.",
    },
    {
        title    : "Find Overdue Tasks",
        icon     : "i5-pastdue",
        isvgIcon : "isvg-time-work-item-date",
        message  : "List all tasks that are overdue and need immediate attention.",
    },
    {
        title    : "Show upcoming deadlines",
        icon     : "i5-calendar-light",
        isvgIcon : "isvg-time-work-item-date",
        message  : "Show the upcoming deadlines across all spaces.",
    },
    {
        title    : "Analyze workload",
        icon     : "i5-timeline",
        isvgIcon : "isvg-time-work-item-user",
        message  : "Analyze the workload distribution and highlight potential overload or imbalance.",
    },
]


export const aiChatProjectPrompt: AiChatSuggestedAction[] = [
    {
        title    : "Summarize this Project",
        icon     : "i5-widget-summary",
        isvgIcon : "isvg-progress-report",
        message  : "Summarize the project, highlighting key updates, progress, blockers, and recent activity.",
    },
    {
        title    : "Find Tasks Without Assignees",
        icon     : "i5-user-assigned",
        isvgIcon : "isvg-time-work-item-user",
        message  : "List all tasks that currently have no assignee and need to be assigned.",
    },
    {
        title    : "Find Overdue Tasks",
        icon     : "i5-pastdue",
        isvgIcon : "isvg-time-work-item-date",
        message  : "List all tasks that are overdue and require immediate attention.",
    }
]


export const aiChatTaskPrompt: AiChatSuggestedAction[] = [
    {
        title       : "Get task info",
        icon        : "i5-widget-summary",
        isvgIcon    : "isvg-progress-report",
        message     : "Analyze and summarize the task information."
    },
    {
        title    : "Suggest next steps",
        icon     : "i5-timeline",
        isvgIcon : "isvg-progress-report",
        message  : "Suggest the next steps to move this task forward based on its current status, description, and discussion."
    },
    {
        title    : "Split into subtasks",
        icon     : "i5-task",
        isvgIcon : "isvg-time-work-item-user",
        message  : "Break this task into clear and actionable subtasks."
    }
]
